import React from 'react';
import { Typography } from "@material-ui/core";

const ProfileSection: React.FC = props => (
    <Typography variant="h6">
        <div style={{ color: "#4a90e2" }}>{props.children}</div>
    </Typography>
);

export default ProfileSection;